export default "__VITE_ASSET__BczCl1kd__"